<template>
  <div class="Parent">
    <Info />
  </div>
</template>

<script>
import Info from '../components/ChargeHelp/Info.vue';

export default {
  components: { Info },
};
</script>
<style scoped>
.Page {
  min-height: 100vh;
  color: black;
}
.Parent {
  max-width: 800px;
  margin: 0 auto;
}
</style>
